export default __webpack_public_path__ + "static/media/str.edb8daff.svg";